export const config = {
  apiKey: "AIzaSyAwDlPvqclSon0DCElfYt3X86AvW5Mt5bc",
  authDomain: "lcf-mapper-2.firebaseapp.com",
  databaseURL: "https://lcf-mapper-2.firebaseio.com",
  projectId: "lcf-mapper-2",
  storageBucket: "lcf-mapper-2.appspot.com",
  messagingSenderId: "901500597950"
};



// WEBPACK FOOTER //
// ./source/js/firebaseConfig.js